'use strict';

var angular = require('angular');
var RuleQuickDirective = function RuleQuickDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rule-quick.html'),
    controller: 'RuleQuickController',
    scope: {
      closePanelHandler: '&',
      activeEntityType: '=',
      rule: '='
    },
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
      scope.$watch('selectedLevel', scope.onPrimaryCriteriaSelectedLevelChanged);
      scope.$watch('ruleStructure', scope.onRuleStructureChanged);
      scope.showConfirmationDialog = function () {
        angular.element('#criteria-rule-quick-modal').appendTo('body').modal('show');
      };
      scope.hideConfirmationDialog = function () {
        angular.element('#criteria-rule-quick-modal').modal('hide');
        angular.element('body').removeClass('modal-open');
        angular.element('#criteria-rule-quick-modal, .modal-backdrop').remove();
      };
    }
  };
};
RuleQuickDirective.$inject = [];
module.exports = RuleQuickDirective;